import VerticalTimelineElement1 from "./VerticalTimelineElement1";
import VerticalTimelineElement2 from "./VerticalTimelineElement2";
import VerticalTimelineElement3 from "./VerticalTimelineElement3";
import VerticalTimelineElement4 from "./VerticalTimelineElement4";
import VerticalTimelineElement5 from "./VerticalTimelineElement5";
import VerticalTimelineElement6 from "./VerticalTimelineElement6";

const Timeline1 = () => {
  return (
    <section className="cd-container" id="cd-timeline">
      <VerticalTimelineElement1 />
      <VerticalTimelineElement2 />
      <VerticalTimelineElement3 />
      <VerticalTimelineElement4 />
      <VerticalTimelineElement5 />
      <VerticalTimelineElement6 />
    </section>
  );
};

export default Timeline1;
